import React from 'react';
import loadable from '@loadable/component';

import keywordSearchPageQuery from './query.graphql';

const KeywordLandingPage = loadable(() =>
  import(
    /* webpackChunkName: "keyword-search-page" */ './components/keyword-search-page'
  )
);

const KeywordSearchPage = ({ data }) => (
  <KeywordLandingPage data={data.keywordLandingPage} />
);

KeywordSearchPage.graphQL = keywordSearchPageQuery;

KeywordSearchPage.skipClientDataRefetch = true;

KeywordSearchPage.variables = vars => {
  return {
    slug: vars.slug,
    query: decodeURIComponent(vars.query),
  };
};

export default KeywordSearchPage;
